import React from "react";

const Header = () => {
  return (
    <div>
      <h1>Real-Time PATH Train Departures</h1>
      <p>by Saowaluck Morales</p>
    </div>
  );
};

export default Header;
